$( document ).ready(function() {
	// FUNCTIONS
	$('a[data-rel^=lightcase]').lightcase();
  mobileMenu();
  iOS_CaretBug();

  // BACK TO TOP
  $(".back-top").hide();
  // fade in #back-top
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      $('.back-top').fadeIn();
      $('.header').addClass('move');
    } else {
      $('.back-top').fadeOut();
      $('.header').removeClass('move');
    }
  });
  // scroll body to 0px on click
  $('.back-top').click(function() {
    $('body,html').animate({
      scrollTop: 0
    }, 800);
    return false;
  });

	// WINDOW ON LOAD
	$(window).on("load", function(){
		caroufredsel_slider();

		// SITE LOADER
		$(".site-loader").css("opacity", 0);
		setTimeout(function(){
			$(".site-loader").css("z-index", -1);
		}, 300);
	});

	// WINDOW ON RESIZE
	$(window).on("resize", function(){
    	caroufredsel_slider();
  	});

  	// IOS INPUT BUG FIX
    (function iOS_CaretBug() {
       var ua = navigator.userAgent,
       scrollTopPosition,
       iOS = /iPad|iPhone|iPod/.test(ua),
       iOS11 = /OS 11_0|OS 11_1|OS 11_2/.test(ua);

       // ios 11 bug caret position
       if ( iOS && iOS11 ) {

           $(document.body).on('show.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Get scroll position before moving top
                   scrollTopPosition = $(document).scrollTop();

                   // Add CSS to body "position: fixed"
                   $("body").addClass("iosBugFixCaret");
               }
           });

           $(document.body).on('hide.bs.modal', function(e) {
               if ( $(e.target).hasClass('modal') ) {
                   // Remove CSS to body "position: fixed"
                   $("body").removeClass("iosBugFixCaret");

                   //Go back to initial position in document
                   $(document).scrollTop(scrollTopPosition);
               }
           });
       }
    })();
});

// CAROUFREDSEL SLIDER
function caroufredsel_slider() {
  $(".cs-slider .slides").each(function(){
    var $this    = $(this);
    var ctrlPrev = $(this).closest(".cs-slider").find(".prev");
    var ctrlNext = $(this).closest(".cs-slider").find(".next");

    $this.carouFredSel({
      auto: {
        play: $this.data("auto"),
        timeoutDuration: $this.data("duration"),
      },
      start      : "random",
      width      : $this.data("cs-width"),
      circular   : $this.data("cs-circular"),
      infinite   : $this.data("cs-infinite"),
      height     : $this.data("cs-height"),
      responsive : $this.data("cs-responsive"),
      direction  : $this.data("cs-direction"),
      prev       : ctrlPrev,
      next       : ctrlNext,
      pagination : "."+$this.data("paginate"),
      scroll:{
        items: $this.data("item-scroll"),
        fx   : $this.data("effects"),
      },
      items:{
        height : $this.data("item-height"),
        width  : $this.data("item-width"),
        visible: {
            min: $this.data("min"),
            max: $this.data("max")
        },
      },
      swipe:true,
    });

    $this.touchwipe({
      wipeUp: function(e) {
        e.preventDefault();
      },
      wipeDown: function(e) {
        e.preventDefault();
      },
      wipeLeft: function(e) {
        $this.trigger("next", 1);
      },
      wipeRight: function(e) {
        $this.trigger("prev", 1);
      }
    });
  });
}

// MOBILE MENU
function mobileMenu() {
  $('.mobile-menu li.menu-item-has-children').prepend('<span class="toggle-menu open"></span>');
  // console.log('test');
  $('#sidepanel .toggle-menu').on('click', function() {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open').addClass('close');
      $(this).siblings('.sub-menu').slideDown();
    } else {
      $(this).removeClass('close').addClass('open');
      $(this).siblings('.sub-menu').slideUp();
    }
  });
  $('body').on('click', '.mobile-trigger', function() {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('#sidepanel').removeClass('active');
      $('body').removeClass('open-sidebar');
    } else {
      $(this).addClass('active');
      $('#sidepanel').addClass('active');
      $('body').addClass('open-sidebar');
    }
  });
}

// IOS INPUT BUG FIX
  function iOS_CaretBug() {
   var ua = navigator.userAgent,
   scrollTopPosition,
   iOS = /iPad|iPhone|iPod/.test(ua),
   iOS11 = /OS 11_0|OS 11_1|OS 11_2/.test(ua);

   // ios 11 bug caret position
   if ( iOS && iOS11 ) {

     $(document.body).on('show.bs.modal', function(e) {
       if ( $(e.target).hasClass('modal') ) {
         // Get scroll position before moving top
         scrollTopPosition = $(document).scrollTop();

         // Add CSS to body "position: fixed"
         $("body").addClass("iosBugFixCaret");
       }
     });

     $(document.body).on('hide.bs.modal', function(e) {
       if ( $(e.target).hasClass('modal') ) {
         // Remove CSS to body "position: fixed"
         $("body").removeClass("iosBugFixCaret");

         //Go back to initial position in document
         $(document).scrollTop(scrollTopPosition);
       }
     });
   }
  }